module.exports = __webpack_public_path__ + "static/img/merchant_case_3.3476c95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_case_3.png
// module id = wkNP
// module chunks = 8